import React from 'react';
import { Sparklines, SparklinesLine } from 'react-sparklines';

const SPARKLINE_DEFAULT_WIDTH = 100;
const SPARKLINE_DEFAULT_HEIGHT = 40;

const Sparkline = ({ data, color = '#062136', width = SPARKLINE_DEFAULT_WIDTH, height = SPARKLINE_DEFAULT_HEIGHT }) => {
  if (!data || data.length === 0) {
    // Generate sample data if none provided
    data = Array.from({ length: 7 }, () => Math.random() * 100 + 50);
  }

  const isPositive = data[data.length - 1] > data[0];
  const lineColor = color === 'auto' ? (isPositive ? '#10B981' : '#EF4444') : color;

  return (
    <Sparklines data={data} width={width} height={height}>
      <SparklinesLine color={lineColor} style={{ strokeWidth: 2, fill: 'none' }} />
    </Sparklines>
  );
};

export default Sparkline;
